(function () {
  document.addEventListener('click', function (e) {

    if (e.target.closest('#b2g1-open')) {
      var overlay = document.getElementById('b2g1-overlay');
      if (!overlay) return;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    if (e.target.closest('#b2g1-close') || e.target.closest('#b2g1-close-x') || e.target.id === 'b2g1-overlay') {
      var overlay = document.getElementById('b2g1-overlay');
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var overlay = document.getElementById('b2g1-overlay');
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });
})();